const SHARE_PATH = /^\/s\/([a-f0-9]{24})\/?$/;

export function shareIdFromPath(pathname: string): string | null {
  return SHARE_PATH.exec(pathname)?.[1] ?? null;
}

export function shareIdFromLocation(
  pathname: string,
  search: string,
): string | null {
  const queryShare = new URLSearchParams(search).get("share")?.trim() ?? "";
  return /^[a-f0-9]{24}$/.test(queryShare)
    ? queryShare
    : shareIdFromPath(pathname);
}

export function canonicalSharePathFromLocation(
  pathname: string,
  search: string,
): string | null {
  const queryShare = new URLSearchParams(search).get("share")?.trim() ?? "";
  if (!/^[a-f0-9]{24}$/.test(queryShare)) return null;
  const canonicalPath = `/s/${queryShare}`;
  return pathname === canonicalPath ? null : canonicalPath;
}

export function referralCodeFromLocation(
  pathname: string,
  search: string,
): string | null {
  const queryReferral = new URLSearchParams(search).get("ref")?.trim();
  if (queryReferral) return queryReferral.slice(0, 64);
  return shareIdFromLocation(pathname, search);
}
